/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PromoTokenType = {
    EXTERNAL_URL: 'EXTERNAL_URL',
    COUPON_CODE: 'COUPON_CODE',
    QR_CODE: 'QR_CODE',
    DYNAMIC_API: 'DYNAMIC_API',
    LOYALTY_POINTS: 'LOYALTY_POINTS',
    MERCHANT_DISCOUNT: 'MERCHANT_DISCOUNT'
} as const;
export type PromoTokenType = typeof PromoTokenType[keyof typeof PromoTokenType];


export function instanceOfPromoTokenType(value: any): boolean {
    for (const key in PromoTokenType) {
        if (Object.prototype.hasOwnProperty.call(PromoTokenType, key)) {
            if (PromoTokenType[key as keyof typeof PromoTokenType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PromoTokenTypeFromJSON(json: any): PromoTokenType {
    return PromoTokenTypeFromJSONTyped(json, false);
}

export function PromoTokenTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromoTokenType {
    return json as PromoTokenType;
}

export function PromoTokenTypeToJSON(value?: PromoTokenType | null): any {
    return value as any;
}

export function PromoTokenTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PromoTokenType {
    return value as PromoTokenType;
}

